import { InventoryBundleData } from "@onmo/graphql/graphql";
import BundleAvatarSession from "../BundleAvatarSession/BundleAvatarSession";
import { useStyles } from "./ShopBundleDetail.style";
import {
  Button,
  GemNumber,
  Image,
  Typography,
  TypographyVariant,
} from "@onmo/ui";
import { useAppSelector } from "../../../hooks";
import { usePurchaseInventory } from "../../../hooks/resolvers/useShopMutation";
import { useTranslation } from "react-i18next";

const ShopBundleDetail: React.FC = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { openBundle } = useAppSelector((state) => state.shop);
  const inventoryBundle = openBundle?.data as InventoryBundleData;
  const purchaseInventory = usePurchaseInventory();

  const onPurchaseInventory = () => {
    if (!openBundle) return;
    purchaseInventory(openBundle, true);
  };

  return (
    <div className={classes.root}>
      <div className={classes.bundlePreview}>
        <Image
          src={inventoryBundle?.previewUrl}
          width={120}
          height={120}
          radius={8}
        />
        <div className={classes.info}>
          <Typography variant={TypographyVariant.HeadingH7Bold}>
            {openBundle?.title}
          </Typography>
          {openBundle?.isPurchased ? (
            <Button fullWidth disabled>
              {t("shop_owned")}
            </Button>
          ) : (
            <Button fullWidth onClick={onPurchaseInventory}>
              {t("buy")} <GemNumber amount={openBundle?.costs[0].amount || 0} />
            </Button>
          )}
        </div>
      </div>
      <BundleAvatarSession bundleId={openBundle?.id} />
    </div>
  );
};
export default ShopBundleDetail;
